<div
  id="sales-monitor-modal"
  role="dialog"
  aria-labelledby="salesMonitorModalLabel"
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ 'agents.trendgptModal.title' | translate }}
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body scroll">
        <form [formGroup]="formGroup">
          <div class="row p-2">
            <div class="card-body">
              <div class="col-xs-12 mb-3">
                <label class="form-label">{{ 'agents.trendgptModal.selectChannelLabel' | translate }}</label>
                <mat-select
                  #ChannelSel
                  class="form-select"
                  formControlName="channels"
                  multiple
                >
                  <mat-option value="" disabled>{{ 'agents.trendgptModal.selectChannelPlaceholder' | translate }}</mat-option>
                  @for(channel of listChannel; track $index ) {
                  <mat-option [value]="channel._id">{{
                    channel.name
                  }}</mat-option>
                  }
                </mat-select>
                <field-error-component
                  [field]="'channels'"
                  [label]="'agents.trendgptModal.channelFieldLabel' | translate"
                  [formGroup]="formGroup"
                ></field-error-component>
              </div>
              <div class="">
                <label for="agentName" class="form-label fw-semibold">
                  {{ 'agents.trendgptModal.agentNameLabel' | translate }}
                </label>
                <input
                  type="text"
                  #agentNameInput
                  id="agentName"
                  class="form-control"
                  maxlength="50"
                  formControlName="name"
                  [placeholder]="'agents.trendgptModal.agentNamePlaceholder' | translate"
                />
                <small class="text-muted float-end">
                  {{ agentNameInput.value?.length || 0 }}/50
                </small>
                <field-error-component
                  [field]="'name'"
                  [label]="'agents.trendgptModal.nameFieldLabel' | translate"
                  [formGroup]="formGroup"
                />
              </div>

              <div class="col-12">
                <label for="product" class="form-label fw-semibold mt-3">
                  {{ 'agents.trendgptModal.productLabel' | translate }}
                </label>
                <input
                  type="text"
                  id="product"
                  class="form-control"
                  formControlName="jobName"
                  [placeholder]="'agents.trendgptModal.productPlaceholder' | translate"
                />
              </div>

              <div class="col-12">
                <label
                  for="agentDescription"
                  class="form-label fw-semibold mt-3"
                >
                  {{ 'agents.trendgptModal.descriptionLabel' | translate }}
                </label>
                <textarea
                  id="agentDescription"
                  #agentDescriptionInput
                  class="form-control"
                  rows="4"
                  maxlength="500"
                  style="resize: none"
                  [placeholder]="'agents.trendgptModal.descriptionPlaceholder' | translate"
                  formControlName="jobDescription"
                ></textarea>
                <div class="text-end">
                  <small class="text-muted">
                    {{ agentDescriptionInput.value?.length || 0 }}/500
                  </small>
                </div>
              </div>

              <div class="col-12">
                <label for="agentBehavior" class="form-label fw-semibold mt-3">
                  {{ 'agents.trendgptModal.behaviorLabel' | translate }}
                </label>
                <textarea
                  id="agentBehavior"
                  #agentBehaviorInput
                  class="form-control"
                  formControlName="behavior"
                  rows="4"
                  maxlength="3000"
                  style="resize: none"
                  [placeholder]="'agents.trendgptModal.behaviorPlaceholder' | translate"
                ></textarea>
                <div class="text-end">
                  <small class="text-muted">
                    {{ agentBehaviorInput.value?.length ?? 0 }}/3000
                  </small>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-light"
          data-bs-dismiss="modal"
          (click)="close()"
        >
          {{ 'agents.trendgptModal.cancelButton' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">
          {{ 'agents.trendgptModal.saveButton' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
